import { createPinia } from 'pinia'
import { useUserStore } from './modules/user'
import { useInteractionBadgeStore } from './modules/interactionBadge'
import { useFeatureStore } from './modules/feature'

const pinia = createPinia()

// 统一导出各子 Store 入口，业务 import { useXxxStore } from '@/store' 即可
export { useUserStore, useInteractionBadgeStore, useFeatureStore }
export default pinia
